import _ from 'lodash';
import moment from 'moment';

import config from "../../app/config";
import {getGroupId} from '../../store/reducers/documents';

class DocumentViewerUtils {
	constructor(documents, historyMode) {
		// this.documents = documents;
		this.documents = _.sortBy(documents, s => this.getStudyDocumentSortCriteria(s));
		this.historyMode = historyMode;
	}

	getStudyDocumentSortCriteria(documentData) {
		return [documentData.metadata.sortOrder, documentData.startDate];
	}

	setHistoryMode(historyMode){
		this.historyMode = historyMode;
	}

	getDocumentById(documentId) {
		let documentToReturn;

		for (let document of this.documents) {
			if (this.getDocumentId(document) === documentId) {
				documentToReturn = document;
				break;
			}
		}

		return documentToReturn;
	}

	getDocumentId(documentData) {
		if (documentData) {
			return documentData.__id;
		}
	}

	getStudy(documentData) {
		if (this.historyMode) {
			if (documentData && documentData.metadata) {
				return documentData.metadata.procedureName;
			}
		} else {
			if (documentData && documentData.metadata) {
				return documentData.metadata.studyId? documentData.metadata.studyId : getGroupId(documentData)
			}
		}
	}

	getLaterality(documentData) {
		if (documentData && documentData.metadata) {
			return documentData.metadata.laterality;
		}
	}

	getProcedureName(documentData) {
		if (documentData && documentData.metadata) {
			return documentData.metadata.procedureName;
		}
	}

	getStudyDocuments(studyId, laterality, type) {
		let studyDocuments = [];
		for (let document of this.documents) {
			if (this.getStudy(document) === studyId) {
				if (!laterality || this.getLaterality(document) === laterality) {
					studyDocuments.push(document);
				}
			}
		}

		return studyDocuments;
	}

	getFirstDocFromStudy(type) {
		let doc = null;

		for (let document of this.documents) {
			if (this.getProcedureName(document) === type) {
				doc = document;
				break;
			}
		}

		if(!doc) return null;

		const studyId = doc.metadata.studyId || getGroupId(doc);

		let studyDocuments = [];
		for (let document of this.documents) {
			if (this.getStudy(document) === studyId) {
				studyDocuments.push(document);
			}
		}
		studyDocuments = this.sortStudyDocuments(studyDocuments);

		return studyDocuments? studyDocuments[0]: null;
	}

	getStudyDocumentsType(studyId, laterality, type) {
		let studyDocuments = [];
		for (let document of this.documents) {
			if (this.getStudy(document) === studyId) {
				if (this.getLaterality(document) === laterality && this.getProcedureName(document) === type) {
					studyDocuments.push(document);
				}
			}
		}

		return studyDocuments;
	}

	getLastDocumentByType(type, laterality) {
		for (let document of this.documents.reverse()) {
			if (this.getProcedureName(document) === type && (!laterality || this.getLaterality(document) === laterality)) {
				return document;
			}
		}
	}

	getLastDocumentsByType(type) {
		let doc = [];
		for (let document of this.documents.reverse()) {
			if (this.getProcedureName(document) === type) {
				doc.push(document);
			}
		}

		return doc;
	}

	getLateralityMaxLen(studyId, type) {
		if(type) {
			const lenR = this.getStudyDocumentsType(studyId, 'R', type).length;
			const lenL = this.getStudyDocumentsType(studyId, 'L', type).length;
			const lenB = this.getStudyDocumentsType(studyId, 'B', type).length;
			return Math.max(lenR, lenL, lenB);
		}
		else {
			const lenR = this.getStudyDocuments(studyId, 'R').length;
			const lenL = this.getStudyDocuments(studyId, 'L').length;
			const lenB = this.getStudyDocuments(studyId, 'B').length;
			return Math.max(lenR, lenL, lenB);
		}
	}

	getLateralityMaxLenByViewMode(studyId, type, mode) {
		const lenR = this.getStudyDocumentsType(studyId, 'R', type).length;
		const lenL = this.getStudyDocumentsType(studyId, 'L', type).length;
		const lenB = this.getStudyDocumentsType(studyId, 'B', type).length;

		switch(mode) {
			case 1:
			case 3:
				return Math.max(lenR, lenL);
			case 2:
			case 4:
				return Math.max(lenR, lenL, lenB);
			case 5:
				return 0;
			default:
				return Math.max(lenR, lenL, lenB);
		}
	}

	getLateralityFitToDefault(laterality, mode) {

		if(!laterality || !mode) return false;

		let m = {
			"B": {
				1: false,
				2: true,
				3: false,
				4: true,
				5: true,
			},
			"L": {
				1: true,
				2: true,
				3: true,
				4: true,
				5: false,
			},
			"R": {
				1: true,
				2: true,
				3: true,
				4: true,
				5: false,
			}
		}
		return m[laterality]? m[laterality][mode]: false
	}

	getDocumentPositionInStudy(documentData, useLaterality) {
		let position = -1;

		let studyDocuments;
		if (useLaterality) {
			studyDocuments = this.getStudyDocumentsType(this.getStudy(documentData), this.getLaterality(documentData), this.getProcedureName(documentData));
		} else {
			studyDocuments = this.getStudyDocuments(this.getStudy(documentData));
		}
		studyDocuments = this.sortStudyDocuments(studyDocuments);

		for (let studyDocIndex in studyDocuments) {
			if (this.getDocumentId(studyDocuments[studyDocIndex]) === this.getDocumentId(documentData)) {
				position = studyDocIndex;
			}
		}

		return parseInt(position);
	}

	getStudyDocumentAtPosition(studyId, position, laterality, type) {
		let docs = this.getStudyDocumentsType(studyId, laterality, type);
		docs = this.sortStudyDocuments(docs);
		return docs && docs.length > position ? docs[position] : null;
	}

	getStudyDocumentAtDate(date, useLaterality) {}

	buildHistoryStampsForDocument(documentData, mode) {
		let returnArray = [];
		let studyDocuments = this.getStudyDocuments(this.getStudy(documentData), this.getLaterality(documentData));

		for (let singleDocument of studyDocuments) {
			if (mode === 1) {
				const dateFormatted =
					singleDocument && singleDocument.startDate
						? moment(singleDocument.startDate).format(config.defaultDateFormat)
						: 'NONE';

				returnArray.push(dateFormatted);
			} else {
				const dateValue = singleDocument && singleDocument.startDate ? moment(singleDocument.startDate) : null;

				returnArray.push(dateValue);
			}
		}

		return returnArray;
	}

	getMaxCount(historyDatesPerDocument, date) {
		let countMax = 0;

		_.forEach(historyDatesPerDocument, (line) => {
			let localCount = 0;
			_.forEach(line, (dateLocal) => {
				if (dateLocal === date) {
					localCount++;
				}
			});
			if (localCount > countMax) {
				countMax = localCount;
			}
		});

		return countMax;
	}

	sortStudyDocuments(documents) {
		return documents.sort((a, b) => {
			const startDateA = a.startDate ? moment(a.startDate).format(config.defaultDateFormat) : 'NONE';
			const startDateB = b.startDate ? moment(b.startDate).format(config.defaultDateFormat) : 'NONE';

			if (startDateA === startDateB) {
				if (a.metadata.sortOrder < b.metadata.sortOrder) return -1;
				if (a.metadata.sortOrder > b.metadata.sortOrder) return 1;
			}

			const startDateMomentA = a.startDate ? moment(a.startDate) : null;
			const startDateMomentB = b.startDate ? moment(b.startDate) : null;

			if (startDateMomentA && startDateMomentB) {
				if (startDateMomentA.isBefore(startDateMomentB)) return -1;
				if (startDateMomentA.isAfter(startDateMomentB)) return 1;
			}
			if (!startDateMomentA && startDateMomentB) return 1;
			if (startDateMomentA && !startDateMomentB) return -1;

			return 0;
		});
	}

	getDocumentForDate(singleDocument, date, localIndex) {
		let currentIndex = 0;
		let previousDate = null;

		let studyDocuments = this.getStudyDocuments(this.getStudy(singleDocument), this.getLaterality(singleDocument));
		// studyDocuments = _.sortBy(studyDocuments, s => s.startDate);
		studyDocuments = this.sortStudyDocuments(studyDocuments);
		for (let singleDocument of studyDocuments) {
			const dateFormatted =
				singleDocument && singleDocument.startDate
					? moment(singleDocument.startDate).format(config.defaultDateFormat)
					: 'NONE';

			if (dateFormatted === previousDate) {
				currentIndex++;
			} else {
				currentIndex = 0;
			}
			previousDate = dateFormatted;

			if (dateFormatted === date && currentIndex === localIndex) {
				return singleDocument;
			}
		}

		return null;
	}

	getDocumentsFodDate(documents, date, localIndex) {
		const docsForDate = [];

		_.forEach(documents, (sd) => docsForDate.push(this.getDocumentForDate(sd, date, localIndex)));

		return docsForDate;
	}

	buildHistoryForDocuments(documents) {
		// ....
		let historyFullSet = new Set();
		let historyDatesPerDocument = [];
		for (let documentIndex in documents) {
			historyDatesPerDocument.push(this.buildHistoryStampsForDocument(documents[documentIndex], 1));
			const singleHistory = this.buildHistoryStampsForDocument(documents[documentIndex], 2);
			_.forEach(singleHistory, (sh) => {
				if (sh) {
					historyFullSet.add(sh.format(config.defaultDateFormat));
				}
			});
		}

		let ii = 0;
		const actualDates = [];

		const _uniqueHistoryDates = Array.from(historyFullSet);
		let __uniqueHistoryDates = [];
		_.forEach(_uniqueHistoryDates, (u) => __uniqueHistoryDates.push(moment(u, config.defaultDateFormat).toDate()));
		__uniqueHistoryDates = _.sortBy(__uniqueHistoryDates).reverse();
		const uniqueHistoryDates = [];
		_.forEach(__uniqueHistoryDates, (u) => uniqueHistoryDates.push(moment(u).format(config.defaultDateFormat)));
		let iii = 0;
		_.forEach(uniqueHistoryDates, (uhd) => {
			const c = this.getMaxCount(historyDatesPerDocument, uhd);
			// This is on request match newer with newer, which not necessary is the correct way?
			for (let i = 0; i < c; i++) {
				const documentsForDate = this.getDocumentsFodDate(documents, uhd, i);
				actualDates.push({
					key: uhd,
					localIdx: i,
					globalIdx: ii,
					groupIdx: iii,
					documents: documentsForDate
				});
				ii++;
			}
			iii++;
		});

		return actualDates;
	}
}

export default DocumentViewerUtils;